import { AfterViewInit, Component, ElementRef, Inject, Optional, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
   selector: 'app-email-body-dialog',
   templateUrl: './email-body.dialog.html',
   styleUrls: ['./email-body.dialog.css']
})
export class EmailBodyDialogComponent implements AfterViewInit {
   constructor(
      @Inject(MAT_DIALOG_DATA) public data: { body: string },
      @Optional() private dialogRef: MatDialogRef<EmailBodyDialogComponent> | null
   ) {}

   @ViewChild('emailIframe') iframe!: ElementRef<HTMLIFrameElement>;

   ngAfterViewInit() {
      const iframe = this.iframe.nativeElement;
      const doc = iframe.contentDocument || iframe.contentWindow!.document;

      doc.open();
      doc.write(this.data.body);
      doc.close();
   }

   dismiss(event: Event) {
      this.dialogRef?.close();
      event.preventDefault();
   }
}
